module.exports = __webpack_public_path__ + "images/logo-env_feature.svg?a21421182b87672af4be7d4f7ccfaa39";